"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.legendHoverHighlightNodes = void 0;
var re_reselect_1 = __importDefault(require("re-reselect"));
var get_chart_id_1 = require("../../../../state/selectors/get_chart_id");
var get_settings_specs_1 = require("../../../../state/selectors/get_settings_specs");
var highlighted_geoms_1 = require("../../layout/utils/highlighted_geoms");
var geometries_1 = require("./geometries");
var getHighlightedLegendItemPath = function (state) { return state.interactions.highlightedLegendPath; };
exports.legendHoverHighlightNodes = re_reselect_1.default([get_settings_specs_1.getSettingsSpecSelector, getHighlightedLegendItemPath, geometries_1.partitionMultiGeometries], function (_a, highlightedLegendItemPath, geometries) {
    var legendStrategy = _a.legendStrategy, flatLegend = _a.flatLegend;
    if (highlightedLegendItemPath.length === 0)
        return [];
    return geometries.flatMap(function (_a) {
        var quadViewModel = _a.quadViewModel;
        return highlighted_geoms_1.highlightedGeoms(legendStrategy, flatLegend, quadViewModel, highlightedLegendItemPath);
    });
})(get_chart_id_1.getChartIdSelector);
//# sourceMappingURL=get_highlighted_shapes.js.map